function checkScrollTop(scrollTopEl) {
  if (document.documentElement.scrollTop > document.documentElement.clientHeight) {
    scrollTopEl.classList.remove('hidden')
  } else {
    scrollTopEl.classList.add('hidden')
  }
}

export function initScrollTop() {
  const scrollTopEl = document.querySelector('.js-scroll-top')

  if (!scrollTopEl) {
    return
  }

  scrollTopEl.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  })

  document.addEventListener('scroll', () => checkScrollTop(scrollTopEl))
  checkScrollTop(scrollTopEl)
}
